import { useEffect, useState } from "react";
import {
  Button,
  CheckPicker,
  Divider,
  Loader,
  Message,
  SelectPicker,
  Tooltip,
  useToaster,
  Whisper,
} from "rsuite";
import QuoteUploadModal from "../../../components/quote-upload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ExecuteAssesmentModal from "../../../components/execute-assessment";
import {
  UploadQuoteLabels as LABELS,
  QuoteUploadStatus,
  UploadQuotesNotes,
} from "../UploadQuoteConstants";
import {
  useExecuteAssessment,
  useQuotDelete,
  useQuotDeleteFilters,
} from "../../../react-query/hooks/HQuoteUpload";
import {
  IGetWireStatusResponse,
  IQuoteUploadFiltersResponse,
  IQuoteUploadStatusPayload,
  IQuoteUploadStatusResponse,
} from "../../../services/interfaces/IQuoteUpload";
import { useAppSelector } from "../../../services/redux/hooks/hooks";
import {
  convertDateToMonthYear,
  formatDateToLong,
} from "../../../utils/helpers/mapModulesToIcon";
import { USER_ROLE } from "../../../utils/constants";
import { appInsights } from "../../../router/router";
import UserGuideDownloadIcon from "../../../assets/user-guide-download-white.svg";
import ProductInfoIcon from "../../../assets/info-circle-grey.svg";
import CustomModal from "../../../components/custom-modal";
import { Link } from "react-router-dom";
import WireUpload from "./wireUpload";
import { useWireFiltersData } from "../../../react-query/hooks/HWireContracts";
import MoreInfoModal from "../../../components/more-info";
import { dateFormatterToDDMMMYYYY } from "../../../utils/formatter";
import { FEATURE_FLAGS } from "../../../utils/featureFlags";
import { toast } from "react-toastify";

type Props = {
  statusData: IQuoteUploadStatusResponse[] | IGetWireStatusResponse;
  quoteUploadStatusPayload: IQuoteUploadStatusPayload | undefined;
  setQuoteUploadStatusPayload: React.Dispatch<
    React.SetStateAction<IQuoteUploadStatusPayload | undefined>
  >;
  filters: IQuoteUploadFiltersResponse;
  commodity: string | undefined;
  setAssessmentExecuting: React.Dispatch<React.SetStateAction<boolean>>;
  screenStatus: boolean;
  // setNegoWeek: React.Dispatch<any>;
};

const VendorQuote = ({
  statusData,
  quoteUploadStatusPayload,
  setQuoteUploadStatusPayload,
  filters,
  commodity,
  setAssessmentExecuting,
  screenStatus,
  // setNegoWeek,
}: Props) => {
  const toaster = useToaster();
  const userDetails = useAppSelector((state) => {
    return state.user;
  });

  const [allowAssessment, setAllowAssessment] = useState(false);
  const [openQuoteModal, setOpenQuoteModal] = useState<boolean>(false);
  const [openQuoteDeleteModal, setOpenQuoteDeleteModal] =
    useState<boolean>(false);
  const [isExecuteAssesmentModalOpen, setIsExecuteAssesmentModalOpen] =
    useState<boolean>(false);

  const [supplierToDelete, setSupplierToDelete] = useState<string | null>(null);
  const [durationToDelete, setDurationToDelete] = useState<string | null>(null);
  const [typeToDelete, setTypeToDelete] = useState<string | null>(null);
  const [districtToDelete, setDistrictToDelete] = useState<string | null>(null);
  const [quoteIDToDelte, setQuoteIdToDelete] = useState<string | null>(null);

  const [isMoreInfo, setIsMoreInfo] = useState(false)
  const [moreInfoMessage, setMoreInforMessage] = useState<any>({ heading: "", message: "" });
  const [modalType, setModalType] = useState<string>("")

  const isCopperWireCommodity = commodity === "Copper Wire";

  const statusRows: any[] = Array.isArray(statusData)
    ? statusData
    : Array.isArray((statusData as any)?.data)
      ? (statusData as any).data
      : Array.isArray((statusData as any)?.data?.data)
        ? (statusData as any).data.data
        : [];
  const firstStatusRow = statusRows[0];
  const getRowField = (row: any, key: string) => {
    if (!row || typeof row !== "object") return undefined;
    const matchKey = Object.keys(row).find(
      (k) => k.toLowerCase() === key.toLowerCase(),
    );
    return matchKey ? row[matchKey] : undefined;
  };
  const rowCommodity = getRowField(firstStatusRow, "commodity");
  const normalizedCommodity = `${commodity ?? ""} ${
    rowCommodity ?? ""
  }`.toLowerCase();
  const isSteelOrPvc =
    normalizedCommodity.includes("steel") ||
    normalizedCommodity.includes("pvc");
  const showCopperWireTables =
    !isCopperWireCommodity || FEATURE_FLAGS.quoteUploadCopperWireTables;



  const {
    wireFilters,
    isLoading,
    refetch: filtersDataRefetch,
  } = useQuotDeleteFilters(
    commodity,
    localStorage.getItem("userEmail"),
    userDetails.role_name,
    districtToDelete,
    supplierToDelete,
    durationToDelete,
    quoteIDToDelte,
    typeToDelete,
  );

  useEffect(() => {
    if (!isLoading) {
      if (quoteIDToDelte?.length) {
        if (!(supplierToDelete && supplierToDelete?.length)) {
          setSupplierToDelete(
            wireFilters?.suppliers.map((ele: string) => ele)[0],
          );
        }
        if (!(durationToDelete && durationToDelete?.length)) {
          setDurationToDelete(
            wireFilters?.contractValidity.map((ele: string) => ele)[0],
          );
        }
        if (!(typeToDelete && typeToDelete?.length)) {
          setTypeToDelete(
            wireFilters?.contractTypes.map((ele: string) => ele)[0],
          );
        }
        if (!(districtToDelete && districtToDelete?.length)) {
          setDistrictToDelete(
            wireFilters?.districts.map((ele: string) => ele)[0],
          );
        }
      }
    }
  }, [wireFilters, quoteIDToDelte, isLoading]);

  const {
    mutate,
    executionSuccess,
    setExecutionSuccess,
    errorExecutionMessage,
    setErrorExecutionMessage,
  } = useExecuteAssessment(setAssessmentExecuting);
  const {
    mutate: deleteWireMuatte,
    isSuccess: deleteSuccess,
    isPending,
    errorMessageDelete: errorMessageDelete,
    setErrorMessageDelete: setErrorMessageDelete,
  } = useQuotDelete(setOpenQuoteDeleteModal);

  useEffect(() => {
    if (commodity) {
      if (commodity === "Copper Wire") {
        filtersDataRefetch();
        // if (wireFilters) {
        //   setNegoWeek(formatDateToLong(wireFilters.week_date));
        // }
      }
      setQuoteUploadStatusPayload({
        commodity: commodity,
        quotation_date:
          filters && Object.keys(filters).length > 0
            ? convertDateToMonthYear(filters?.date)
            : "",
      });
      let checkAssessment =
        userDetails?.role_name === USER_ROLE.Lead &&
          Array.isArray(statusData) &&
          statusData?.length !== 0
          ? true
          : filters?.allowAssessment && filters?.allowAssessment?.length !== 0
            ? (filters?.allowAssessment?.find(
              (filter) => filter?.commodity === commodity,
            )?.allowAssessment ?? false)
            : false;
      if (
        userDetails?.role_name === "Manager" &&
        !userDetails?.userCommArray.includes(commodity)
      ) {
        checkAssessment = false;
      }
      setAllowAssessment(checkAssessment);
    }
  }, [commodity, statusData, filters, userDetails]);

  useEffect(() => {
    if (executionSuccess) {
      
      toast.success("Assessment Executed Successfully!");
      setExecutionSuccess(false);
      // setAssessmentExecuting(false);
    }

    if (errorExecutionMessage) {
      toaster.push(
        <Message showIcon type={"error"} closable>
          <strong>{errorExecutionMessage}</strong>
        </Message>,
        { placement: "topCenter", duration: 5000 },
      );
      setErrorExecutionMessage(undefined);
      setAssessmentExecuting(false);
    }
    if (errorMessageDelete) {
      toaster.push(
        <Message showIcon type={"error"} closable>
          <strong>{errorMessageDelete}</strong>
        </Message>,
        { placement: "topCenter", duration: 5000 },
      );
      setErrorMessageDelete(null);
    }
    if (deleteSuccess) {
      toaster.push(
        <Message showIcon type={"success"} closable>
          <strong>Quote Deleted Successful!</strong>
        </Message>,
        { placement: "topCenter", duration: 5000 },
      );
    }
  }, [
    executionSuccess,
    errorExecutionMessage,
    errorMessageDelete,
    deleteSuccess,
  ]);

  const handleExecuteAssessment = () => {
    if (!quoteUploadStatusPayload) return;

    mutate(quoteUploadStatusPayload, {
      onSuccess: (response: any) => {
       
        const data = response?.data;
        const nestedData = response?.data?.data;

        if (
          (typeof data === "string" && data.includes("Execute Assessment Successful")) ||
          (typeof nestedData === "string" && nestedData.includes("Execute Assessment Successful"))
        ) {

          toaster.push(
            <Message showIcon type={"success"} closable>
              <strong>Assessment Executed Successfully!</strong>
            </Message>,
            { placement: "topCenter", duration: 5000 },
          );
        }
      },
    });

    setAssessmentExecuting(true);
    setIsExecuteAssesmentModalOpen(false);
    appInsights.trackEvent({
      name: "Quote Upload: Execute Assessment",
      properties: {
        description: `${localStorage.getItem(
          "userEmail",
        )} has clicked on Execute Assessment Button`,
      },
    });
  };

  const handleDelete = () => {
    if (
      districtToDelete &&
      supplierToDelete &&
      durationToDelete &&
      quoteIDToDelte &&
      typeToDelete
    ) {
      if (quoteUploadStatusPayload) {
        deleteWireMuatte({
          payload: {
            userEmail: localStorage.getItem("userEmail"),
            district: districtToDelete,
            supplier: supplierToDelete,
            contractValidity: durationToDelete,
            quote_id: quoteIDToDelte,
            contractType: typeToDelete,
          },
          refetchPayload: quoteUploadStatusPayload,
        });
        setDistrictToDelete(null);
        setSupplierToDelete(null);
        setDurationToDelete(null);
        setQuoteIdToDelete(null);
        setTypeToDelete(null);
        appInsights.trackEvent({
          name: "Quote Upload: Quote Delete",
          properties: {
            description: `${localStorage.getItem(
              "userEmail",
            )} has clicked on Quote Delete Button`,
          },
        });
      }
    }
  };
  return (
    <>
      <div className="bg-[#F1F1F1] grow shrink min-w-0 p-[2%] pr-[5%] flex flex-col flex-nowrap justify-start items-start gap-[1vw] h-full w-full">
        <span className="w-full bg-white font-bold p-pd13 shadow-module-card border border-[#bebebe] text-fs16 rounded-md flex justify-between items-center">
          <span className="text-[1.8vh] flex items-center gap-[0.5vw]">
            {LABELS.quoteUpload}
          </span>
          <div className="flex">
            <div>
              <a
                download={"Supplier Quote Upload Template"}
                style={{ textDecoration: "none" }}
                href={
                  commodity === "Copper Wire"
                    ? require("../../../assets/Wire Upload Template.xlsx")
                    : require("../../../assets/Commodity Connect SPVC Quote Upload Template.xlsx")
                }
              >
                <div className="cursor-not-allowed flex justify-center items-center bg-deloitteGreen rounded px-[1.2vw] py-[1vh] mr-[1.5vw]">
                  <img
                    className="h-[2vh]"
                    src={UserGuideDownloadIcon}
                    alt="Download User Guide"
                  />
                  <button
                    onClick={() => { }}
                    className={`text-[1.8vh] font-semibold text-white ml-[0.5vw]  `}
                  >
                    {LABELS.downloadTemp}
                  </button>
                </div>
              </a>
            </div>

            <div>
              {userDetails.userCanEditArray.includes("Quote Upload") && (
                <button
                  disabled={
                    screenStatus &&
                    !allowAssessment &&
                    userDetails.role_name !== "Lead"
                  }
                  onClick={() => {
                    setOpenQuoteModal(true);
                  }}
                  className={`text-[1.8vh] w-[7vw] font-semibold bg-deloitteGreen rounded text-white px-[1.2vw] py-[1vh] mr-[1.5vw]`}
                >
                  Upload
                </button>
              )}
            </div>
            {commodity === "Copper Wire" && (
              <div>
                {userDetails.userCanEditArray.includes("Quote Upload") && (
                  <button
                    disabled={
                      screenStatus &&
                      !allowAssessment &&
                      userDetails.role_name !== "Lead"
                    }
                    onClick={() => {
                      setOpenQuoteDeleteModal(true);
                    }}
                    className={`text-[1.8vh] w-[7vw] font-semibold bg-deloitteGreen rounded text-white px-[1.2vw] py-[1vh] mr-[1.5vw]`}
                  >
                    Delete
                  </button>
                )}
              </div>
            )}
            {commodity === "Copper Wire" &&
              FEATURE_FLAGS.quoteUploadCopperWireTables &&
              userDetails.userCanEditArray.includes("Quote Upload") && (
                <div>
                  <button
                    onClick={() => {
                      setIsExecuteAssesmentModalOpen(true);
                    }}
                    className={`text-[1.8vh] font-semibold bg-deloitteGreen rounded text-white px-[1.2vw] py-[1vh] mr-[1.5vw] ${
                      !screenStatus ||
                      (!allowAssessment && userDetails?.role_name !== "Lead")
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                    disabled={
                      !screenStatus ||
                      (!allowAssessment && userDetails?.role_name !== "Lead")
                    }
                  >
                    {LABELS.executeAssessment}
                  </button>
                </div>
              )}
          </div>
        </span>
        <span className="w-full bg-white font-bold p-pd13 shadow-module-card border border-[#bebebe] text-fs16 rounded-md">
          <div> {LABELS.note}</div>
          <div className="text-fs14 font-semibold">
            <ul
              style={{
                listStyleType: "disc",
                padding: "0 2%",
                fontSize: "0.8vw",
              }}
            >
              {UploadQuotesNotes.map((note) => (
                <li key={note}>{note}</li>
              ))}
            </ul>
          </div>
        </span>
        {!isCopperWireCommodity && Array.isArray(statusData) ? (
          <div className="w-full business-cost-setting-table">
            <DataTable
              sortField={LABELS.commodityKey}
              sortOrder={-1}
              removableSort
              value={Array.isArray(statusData) && statusData ? statusData : []}
              stripedRows
              scrollable
              scrollHeight="40vh"
              showGridlines
              emptyMessage={LABELS.emptyMessage}
            // rowGroupMode="rowspan"
            // groupRowsBy={LABELS.commodityKey}
            >
              {QuoteUploadStatus.map((column) => (
                <Column
                  key={column.field}
                  field={column.field}
                  header={
                    column.header === "Vendor" ? "Supplier" : column.header
                  }
                  body={
                    column.field !== "vendor"
                      ? (rowData: any) => {
                          const value = rowData?.[column.field];
                          const rowUploadedBy = getRowField(
                            rowData,
                            "CREATED_BY",
                          );
                          const rowUploadedOn = getRowField(
                            rowData,
                            "CREATED_AT",
                          );
                          const showRowInfo =
                            isSteelOrPvc &&
                            Boolean(value) &&
                            Boolean(rowUploadedBy || rowUploadedOn);
                          return (
                            <span className="flex items-center gap-[0.4vw]">
                              {value}
                              {showRowInfo && (
                                <Whisper
                                  placement="top"
                                  trigger="hover"
                                  speaker={
                                    <Tooltip>
                                      Uploaded on{" "}
                                      {dateFormatterToDDMMMYYYY(rowUploadedOn)}
                                      {rowUploadedBy
                                        ? ` by ${rowUploadedBy}`
                                        : ""}
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    className="w-[1.6vh] cursor-pointer inline"
                                    src={ProductInfoIcon}
                                    alt="info"
                                  />
                                </Whisper>
                              )}
                            </span>
                          );
                        }
                      : undefined
                  }
                />
              ))}
            </DataTable>
          </div>
        ) : (
          <div className="w-full min-w-0 sku-table min-h-[30vh]">
            {!Array.isArray(statusData) && (
              <WireUpload
                statusData={statusData}
                weekDate={formatDateToLong(filters?.date_wire)}
                useLegacyTable={!showCopperWireTables}
                quotationDate={filters?.date_wire}
                commodity={commodity}
              />
            )}
          </div>
        )}
        {userDetails.userCanEditArray.includes("Quote Upload") &&
          commodity !== "Copper Wire" && (
            <div className="w-full flex justify-center bg-white font-bold px-[1vw] py-[1vw] shadow-module-card border border-[#bebebe] text-fs16 rounded-md">
              <button
                onClick={() => {
                  setIsExecuteAssesmentModalOpen(true);
                }}
                className={`text-[1.8vh] font-semibold bg-deloitteGreen rounded text-white px-[1.2vw] py-[1.2vh] ${
                  !screenStatus ||
                  (!allowAssessment && userDetails?.role_name !== "Lead")
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer"
                }`}
                disabled={
                  !screenStatus ||
                  (!allowAssessment && userDetails?.role_name !== "Lead")
                }
              >
                {LABELS.executeAssessment}
              </button>
            </div>
          )}
      </div>

      {openQuoteModal && (
        <QuoteUploadModal
          setMoreInforMessage={setMoreInforMessage}
          moreInfoMessage={moreInfoMessage}
          setIsMoreInfo={setIsMoreInfo}
          openQuoteModal={openQuoteModal}
          setModalType={setModalType}
          setOpenQuoteModal={setOpenQuoteModal}
          negotiationMonth={
            filters && Object.keys(filters).length > 0
              ? convertDateToMonthYear(filters?.date)
              : undefined
          }
          commodity={commodity}
          quoteUploadStatusPayload={quoteUploadStatusPayload}
          wireQuotationDate={filters?.date_wire}
          screenStatus={screenStatus}
          allowAssessment={
            filters?.allowAssessment && filters?.allowAssessment?.length !== 0
              ? (filters?.allowAssessment?.find(
                (filter) => filter?.commodity === commodity,
              )?.allowAssessment ?? false)
              : false
          }
          role={userDetails?.role_name}
        />
      )}

      {isMoreInfo && <MoreInfoModal
        isMoreInfo={isMoreInfo}
        setIsMoreInfo={setIsMoreInfo}
        moreInfoMessage={moreInfoMessage}
        type={modalType}
      />}
      {commodity === "Copper Wire" && openQuoteDeleteModal && (
        <CustomModal
          openModal={openQuoteDeleteModal}
          closeModal={() => {
            setOpenQuoteDeleteModal(false);
            setDistrictToDelete(null);
            setSupplierToDelete(null);
            setDurationToDelete(null);
            setQuoteIdToDelete(null);
            setTypeToDelete(null);
          }}
          isloading={false}
          header="Quote Delete"
          footer=""
        >
          <div className="flex flex-col gap-[2vh] max-h-[60vh]">
            <div className="flex w-full justify-between items-center gap-[4%]">
              <div className="flex flex-col justify-start items-start w-[48%]">
                <label className="font-bold text-fs16" htmlFor="supplierPicker">
                  Supplier
                </label>
                <SelectPicker
                  style={{ width: "100%" }}
                  id="supplierPicker"
                  labelKey="supplier"
                  valueKey="supplier"
                  data={
                    wireFilters?.suppliers.length
                      ? [
                        ...wireFilters?.suppliers.map((ele: string) => ({
                          supplier: ele,
                        })),
                      ]
                      : []
                  }
                  value={supplierToDelete}
                  onChange={(value: string | null) =>
                    setSupplierToDelete(value)
                  }
                  preventOverflow={true}
                  onOpen={() => { }}
                />
              </div>
              <div className="flex flex-col justify-start items-start w-[48%]">
                <label className="font-bold text-fs16" htmlFor="CDPicker">
                  Contract Duration
                </label>
                <SelectPicker
                  style={{ width: "100%" }}
                  id="CDPicker"
                  labelKey="contractValidity"
                  valueKey="contractValidity"
                  data={
                    wireFilters?.contractValidity.length
                      ? [
                        ...wireFilters?.contractValidity.map(
                          (ele: string) => ({
                            contractValidity: ele,
                          }),
                        ),
                      ]
                      : []
                  }
                  value={durationToDelete}
                  onChange={(value: string | null) =>
                    setDurationToDelete(value)
                  }
                />
              </div>
            </div>
            <div className="flex w-full justify-between items-center gap-[4%]">
              <div className="flex flex-col justify-start items-start w-[48%]">
                <label className="font-bold text-fs16" htmlFor="CTPicker">
                  Contract Type
                </label>
                <SelectPicker
                  style={{ width: "100%" }}
                  id="CTPicker"
                  labelKey="contractType"
                  valueKey="contractType"
                  data={
                    wireFilters?.contractTypes.length
                      ? [
                        ...wireFilters?.contractTypes.map((ele: string) => ({
                          contractType: ele,
                        })),
                      ]
                      : []
                  }
                  value={typeToDelete}
                  onChange={(value: string | null) => setTypeToDelete(value)}
                />
              </div>
              <div className="flex flex-col justify-start items-start w-[48%]">
                <label className="font-bold text-fs16" htmlFor="DistrictPicker">
                  District
                </label>
                <SelectPicker
                  style={{ width: "100%" }}
                  id="DistrictPicker"
                  labelKey="district"
                  valueKey="district"
                  data={
                    wireFilters?.districts.length
                      ? [
                        ...wireFilters?.districts.map((ele: string) => ({
                          district: ele,
                        })),
                      ]
                      : []
                  }
                  value={districtToDelete}
                  onChange={(value: string | null) =>
                    setDistrictToDelete(value)
                  }
                />
              </div>
            </div>
            <div className="flex w-full justify-between items-center gap-[4%]">
              <div className="flex flex-col justify-start items-start w-[48%]">
                <label className="font-bold text-fs16" htmlFor="QuoteIdPicker">
                  Quote ID
                </label>
                <SelectPicker
                  style={{ width: "100%" }}
                  id="QuoteIdPicker"
                  labelKey="quoteId"
                  valueKey="quoteId"
                  data={
                    wireFilters?.quoteIds.length
                      ? [
                        ...wireFilters?.quoteIds.map((ele: string) => ({
                          quoteId: ele,
                        })),
                      ]
                      : []
                  }
                  value={quoteIDToDelte}
                  onChange={(value: string | null) => setQuoteIdToDelete(value)}
                />
              </div>
            </div>
            {districtToDelete &&
              supplierToDelete &&
              durationToDelete &&
              quoteIDToDelte &&
              typeToDelete &&
              wireFilters?.base_sku && (
                <div className="flex flex-col gap-[1vh] w-full justify-center items-start text-fs16 max-h-[20vh]">
                  <div className="w-full overflow-y-auto">
                    {wireFilters.base_sku.map((ele: any, i: any) => (
                      <div className="py-[0.1vh]">
                        <span className="font-bold ">
                          {Object.keys(ele)[0]}:{" "}
                        </span>
                        <span>{ele[Object.keys(ele)[0]]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            <div className="w-full flex justify-center items-center pt-[1vh]">
              <button
                className={`w-[20%] text-[0.8vw] font-semibold bg-deloitteGreen rounded-md text-white px-[0.8vw] py-[0.8vh] ${districtToDelete &&
                  supplierToDelete &&
                  durationToDelete &&
                  quoteIDToDelte &&
                  typeToDelete
                  ? "cursor-pointer"
                  : "cursor-not-allowed opacity-50"
                  }`}
                disabled={
                  districtToDelete &&
                    supplierToDelete &&
                    durationToDelete &&
                    quoteIDToDelte &&
                    typeToDelete
                    ? false
                    : true
                }
                onClick={() => handleDelete()}
              >
                Delete
              </button>
            </div>
          </div>
        </CustomModal>
      )}
      {isExecuteAssesmentModalOpen && (
        <ExecuteAssesmentModal
          isOpen={isExecuteAssesmentModalOpen}
          handleCancel={() => setIsExecuteAssesmentModalOpen(false)}
          handleExecute={handleExecuteAssessment}
        />
      )}
      {/* {true && (
        <CustomModal
          openModal={true}
          closeModal={() => null}
          isloading={false}
          header="Warning !!!"
          footer=""
          closeable={false}
        >
          <div className="flex justify-start items-center w-full px-[1vh] pb-[2.5vh]">
            <span className="text-[0.9vw] font-semibold text-red-800">
              <span>Commodity Index is not updated for </span>
              <span className="text-deloitteGreen">
                {convertDateToMonthYear(month)}
              </span>
              .<span> Please update the index first for </span>
              <span className="text-deloitteGreen">
                {convertDateToMonthYear(month)}
              </span>
              <span> to get the latest target cost.</span>
            </span>
          </div>
          <div className="flex justify-center items-center">
            <Link
              to={{ pathname: "/upload-quote" }}
              state={{ hiddenParam: "additionalInputs" }}
              className="w-[50%] flex justify-center items-center no-underline hover:no-underline"
            >
              <Button className="w-full font-bold text-[0.8vw] pl-[0.2vw] bg-deloitteGreen text-white hover:bg-deloitteGreen hover:text-white active:bg-deloitteGreen focus:bg-deloitteGreen">
                Update Index Now
              </Button>
            </Link>
          </div>
        </CustomModal>
      )} */}
    </>
  );
};

export default VendorQuote;
